import type { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const memberQueryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

export function AppProviders({ children }: { readonly children: ReactNode }) {
  return <QueryClientProvider client={memberQueryClient}>{children}</QueryClientProvider>;
}
